import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-talent-pool-demo-redirect",
  template: "",
})
export class TalentPoolDemoRedirectComponent implements OnInit {
  constructor(private readonly router: Router) {}

  ngOnInit(): void {
    const url = environment.talentPoolDemoUrl;
    if (url) {
      window.location.href = url;
    } else {
      void this.router.navigate(["/app/dashboard"]);
    }
  }
}
